// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"2f8240e1","128":"771a811e","153":"7e7a13fd","407":"688dc176","408":"555ade4a","452":"7e69c458","453":"334c49d8","521":"059cbcb8","902":"f7297680"}[chunkId] + ".chunk.js";
};